import React from 'react'

export default function () {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
      <g fill="none" fillRule="evenodd">
        <path fill="#FFF" stroke="#979797" d="M-430.5 -3146.5H1726.5V214.5H-430.5z" opacity=".05" />
        <path
          fill="#999"
          d="M22 6c2.21 0 4 1.79 4 4v14c0 2.21-1.79 4-4 4h-9c-2.21 0-4-1.79-4-4V10c0-2.21 1.79-4 4-4zm0 2h-9c-1.105 0-2 .895-2 2v14c0 1.105.895 2 2 2h9c1.105 0 2-.895 2-2V10c0-1.105-.895-2-2-2zm-5-6c1.864 0 3.43 1.275 3.874 3h-2.141c-.323-.557-.906-.945-1.584-.995L17 4H8c-1.054 0-1.918.816-1.995 1.85L6 6v14c0 1.054.816 1.918 1.85 1.995L8 22v2c-2.142 0-3.891-1.684-3.995-3.8L4 20V6c0-2.142 1.684-3.891 3.8-3.995L8 2h9zm3 16c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L20 20h-6c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L14 18h6zm-3-4c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L17 16h-3c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L14 14h3zm4-4c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L21 12h-7c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L14 10h7z"
        />
      </g>
    </svg>
  )
}
